import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeHeaderModule } from 'se-fe-header'
import { ProgressCircleComponent } from './progress-circle/progress-circle.component'
import { SetupBarComponent } from './setup-bar/setup-bar.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeHeaderModule
  ],
  declarations: [SetupBarComponent, ProgressCircleComponent],
  exports: [SetupBarComponent, ProgressCircleComponent],
})
export class SharedUiSetupBarModule {}
